import { css } from '@emotion/core'
import * as MQ from 'styles/media-queries'

export const container = css`
  display: flex;
`
export const menu = css`
  display: none;
  ${MQ.NOT_TABLETS} {
    display: block;
  }
`

export const section = css`
  ${MQ.PHONES} {
    width: 100vw;
  }
`

export const menuPhone = css`
  display: none;
  ${MQ.TABLETS} {
    max-width: 40%;
    display: block;
  }
`

export const main = css`
  flex: 5;
  width: 100%;
  ${MQ.PHONES} {
    max-width: 100vw;
  }
`
